export default "__VITE_ASSET__RygvxV50__"